import React from 'react';
import { FaTimes, FaExternalLinkAlt, FaCheckCircle } from 'react-icons/fa';
import { Certification } from '../data/portfolioData';

interface CertificationModalProps {
  certification: Certification;
  onClose: () => void;
}

const CertificationModal: React.FC<CertificationModalProps> = ({ certification, onClose }) => {
  // Close on overlay click
  const handleOverlayClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  // Close on Escape key & disable body scroll
  React.useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', handleEscape);
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = '';
    };
  }, [onClose]);

  return (
    <div className="modal-overlay" onClick={handleOverlayClick}>
      <div className="modal" role="dialog" aria-modal="true">
        {/* Image Banner */}
        <img
          src={certification.image}
          alt={certification.title}
          className="modal__image"
        />

        <div className="modal__body">
          {/* Header */}
          <div className="modal__header">
            <div>
              <span className="modal__section-label" style={{ display: 'block', marginBottom: '4px' }}>
                {certification.issuer} • {certification.date}
              </span>
              <h2 className="modal__name">{certification.title}</h2>
            </div>
            <button className="modal__close" onClick={onClose} aria-label="Fermer">
              <FaTimes />
            </button>
          </div>

          {/* Sections */}
          <div className="modal__sections">
            {/* Overview */}
            <div className="modal__section">
              <div className="modal__section-label">Présentation & Objectifs</div>
              <p className="modal__section-text">{certification.overview}</p>
            </div>

            {/* Skills Acquired */}
            <div className="modal__section">
              <div className="modal__section-label">Compétences acquises</div>
              <ul style={{ listStyle: 'none', padding: 0, marginTop: '8px', display: 'flex', flexDirection: 'column', gap: '8px' }}>
                {certification.skillsAcquired.map((skill, index) => (
                  <li key={index} style={{ display: 'flex', alignItems: 'center', gap: '10px', color: 'var(--color-text-secondary)', fontSize: '0.95rem' }}>
                    <FaCheckCircle color="var(--color-blue-400)" size={14} style={{ flexShrink: 0 }} />
                    <span>{skill}</span>
                  </li>
                ))}
              </ul>
            </div>

            {/* Impact / Apport */}
            <div className="modal__section">
              <div className="modal__section-label">Ce que cette formation m'a apporté</div>
              <p className="modal__section-text">{certification.impact}</p>
            </div>
          </div>

          {/* CTA */}
          {certification.verifyUrl && (
            <div className="modal__cta">
              <a
                href={certification.verifyUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn--primary"
              >
                <FaExternalLinkAlt size={14} />
                Visiter  la certification
              </a>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CertificationModal;
